export const frostEs = {
  frost: {
    title: "Protección contra Heladas",
    subtitle: "Sistema avanzado de predicción de heladas con alertas SMS y recomendaciones de protección",
    selectParcel: "Seleccionar Parcela",
    selectParcelDesc: "Elige una parcela para ver las predicciones de heladas",
    selectParcelPlaceholder: "Selecciona una parcela",
    noPredictions: "Selecciona una parcela para ver predicciones de heladas",
    premiumMonitor: "Monitor Premium de Heladas",
    prediction48h: "Predicción 48-72h con datos meteorológicos reales",
    updatePrediction: "Actualizar Predicción",
    updating: "Actualizando...",
    generating: "Generando...",
    generatePredictions: "Generar Predicciones",
    noPredictionsYet: "No hay predicciones de heladas disponibles",
    predictions72h: "Predicciones 72h",
    inHours: "En {{hours}} horas",
    frostAlert: "¡ALERTA DE HELADA!",
    highRiskPredictions: "{{count}} predicciones de alto riesgo en las próximas {{hours}} horas",
    riskLevels: {
      none: "Ninguno",
      low: "Bajo",
      moderate: "Moderado",
      high: "Alto",
      extreme: "Extremo"
    },
    metrics: {
      temperature: "Temperatura",
      probability: "Probabilidad",
      wind: "Viento",
      humidity: "Humedad",
      clouds: "Nubes"
    },
    terrain: {
      title: "Análisis de Terreno y Drenaje de Heladas",
      subtitle: "Datos de elevación NASADEM para evaluación de riesgo de drenaje de aire frío",
      elevation: "Elevación",
      aboveSeaLevel: "Sobre el nivel del mar",
      slope: "Pendiente",
      terrainGradient: "Gradiente del terreno",
      aspect: "Orientación",
      slopeDirection: "Dirección de la pendiente",
      frostPocketRisk: "Riesgo de Bolsa de Helada",
      coldAirPooling: "Acumulación de aire frío",
      coldAirDrainage: "Evaluación de Drenaje de Aire Frío",
      elevatedRisk: "Basándose en el análisis del terreno, esta parcela tiene un riesgo elevado de acumulación de aire frío durante noches despejadas y tranquilas. Considere medidas de protección activa contra heladas.",
      lowRisk: "Basándose en el análisis del terreno, esta parcela tiene un riesgo moderado a bajo de drenaje de aire frío. Se recomienda monitoreo estándar.",
      dataSource: "Fuente de datos: NASADEM (resolución 30m) vía CREODIAS. La elevación afecta el enfriamiento radiativo y los patrones de drenaje de aire frío."
    },
    thresholds: {
      title: "Umbrales de Daño por Helada",
      subtitle: "Temperaturas de referencia a las que ocurre daño por helada según cultivo y etapa de crecimiento",
      crop: "Cultivo",
      criticalTemp: "Temp. Crítica (Tc)",
      growthStage: "Etapa de Crecimiento",
      notes: "Notas",
      tip: "Use la Temperatura Crítica (Tc) de su cultivo como Umbral de Helada abajo. Configure un valor ligeramente mayor (ej., +1°C) para alertas anticipadas.",
      scientificRefs: "Referencias Científicas"
    },
    alertConfig: {
      title: "Configuración de Alertas",
      subtitle: "Personaliza cómo y cuándo recibir alertas de heladas",
      enableSms: "Alertas SMS",
      enableEmail: "Alertas por Email",
      phoneNumber: "Número de Teléfono",
      threshold: "Umbral de Temperatura (°C)",
      advanceNotice: "Aviso Anticipado (horas)",
      saveConfig: "Guardar Configuración",
      saving: "Guardando...",
      configSaved: "Configuración Guardada",
      configSavedDesc: "Las alertas de heladas se han configurado correctamente"
    },
    recommendedActions: "Acciones recomendadas:",
    dataSource: "Datos:"
  },
  climateReport: {
    title: "Informe de Evento Climático",
    subtitle: "Climate Event Report",
    generateReport: "Generar Informe de Evento",
    generating: "Generando...",
    eventSummary: "Resumen del Evento",
    eventType: "Tipo de Evento",
    frost: "Helada",
    dateRange: "Rango de Fechas",
    maxProbability: "Probabilidad Máxima",
    riskLevel: "Nivel de Riesgo",
    parcelInfo: "Información de Parcela",
    parcelName: "Nombre",
    crop: "Cultivo",
    location: "Ubicación",
    area: "Superficie",
    frostExposure: "Exposición a Heladas",
    meteorologicalData: "Datos Meteorológicos",
    dataSource: "Fuente de Datos",
    model: "Modelo",
    factors: "Factores",
    date: "Fecha",
    minTemp: "Temp. Mín",
    probability: "Probabilidad",
    impactAssessment: "Evaluación de Impacto",
    affectedArea: "Superficie estimada afectada",
    damagePotential: "Potencial de daño al cultivo",
    criticalThreshold: "Umbral de temperatura crítica",
    certification: "Certificación y Aviso Legal",
    reportId: "ID del Informe",
    generatedAt: "Generado El",
    modelConfidence: "Confianza del Modelo",
    disclaimer: "Este informe se genera basándose en modelos predictivos utilizando datos meteorológicos de Open-Meteo y AEMET. No reemplaza la evaluación profesional de agrónomos o peritos de seguros. Sentinel Crop proporciona este análisis únicamente con fines informativos.",
    downloadPdf: "Descargar Informe PDF",
    noFrostEvents: "No se detectaron eventos de helada significativos",
    noFrostEventsDesc: "No hay predicciones de riesgo ALTO o EXTREMO de heladas para esta parcela. Genere un informe cuando ocurran eventos de helada."
  }
};
